interface StatesWithOverlappingLabels {
  [x: string]: {
    offsetX: number
    offsetY: number
  }
}

export const statesWithOverlappingLabels: StatesWithOverlappingLabels = {
  // Brasil
  'BR-RN': {
    offsetX: 30,
    offsetY: -70
  },
  'BR-PB': {
    offsetX: 70,
    offsetY: -40
  },
  'BR-PE': {
    offsetX: 130,
    offsetY: -10
  },
  'BR-AL': {
    offsetX: 60,
    offsetY: 10
  },
  'BR-SE': {
    offsetX: 50,
    offsetY: 50
  },
  'BR-RJ': {
    offsetX: 50,
    offsetY: 25
  },
  'BR-ES': {
    offsetX: 50,
    offsetY: 15
  },
  // Chile
  'CL-AP': {
    offsetX: 30,
    offsetY: 0
  },
  'CL-CO': {
    offsetX: 50,
    offsetY: -10
  },
  'CL-VS': {
    offsetX: 30,
    offsetY: 0
  },
  'CL-ST': {
    offsetX: 40,
    offsetY: 0
  },
  'CL-LI': {
    offsetX: 40,
    offsetY: 5
  },
  'CL-BI': {
    offsetX: 50,
    offsetY: 0
  },
  'CL-LR': {
    offsetX: 40,
    offsetY: 0
  },
  'CL-LL': {
    offsetX: 50,
    offsetY: 0
  },
  'CL-MA': {
    offsetX: 70,
    offsetY: -50
  }
}
